import React from 'react';
import StarIcon from '@mui/icons-material/Star';
interface TestimonialProps {
  initials: string;
  quote: string;
  name: string;
  location: string;
}
export function TestimonialCard({
  initials,
  quote,
  name,
  location
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-260">
      <div className="flex items-center mb-4" data-id="element-261">
        <div className="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold text-lg mr-4" data-id="element-262">
          {initials}
        </div>
        <div data-id="element-263">
          <div className="flex text-amber-400 text-sm mb-1" data-id="element-264">
            <StarIcon fontSize="inherit" data-id="element-265" />
            <StarIcon fontSize="inherit" data-id="element-266" />
            <StarIcon fontSize="inherit" data-id="element-267" />
            <StarIcon fontSize="inherit" data-id="element-268" />
            <StarIcon fontSize="inherit" data-id="element-269" />
          </div>
          <p className="text-xs text-gray-500 font-medium" data-id="element-270">Compra verificada</p>
        </div>
      </div>
      <p className="text-gray-700 italic flex-grow mb-4" data-id="element-271">"{quote}"</p>
      <div className="mt-auto pt-4 border-t border-gray-50" data-id="element-272">
        <p className="font-bold text-gray-900" data-id="element-273">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-274">{location}</p>
      </div>
    </div>;
}